import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "minutesToTime",
  standalone: true,
})
export class MinutesToTimePipe implements PipeTransform {
  transform(value: number | undefined): string {
    if (value == null) {
      return "00:00";
    }

    const hours = Math.floor(value / 60);
    const minutes = value % 60;

    const formattedHours = hours.toString();
    const formattedMinutes = minutes.toString().padStart(2, "0");

    return `${formattedHours}:${formattedMinutes.replace("-", "")}`;
  }
}
